import { ScrollArea } from "@/components/ui/scroll-area";

interface AssociatedUser {
  userId: string;
  firstName: string;
  lastName: string;
  email?: string;
  identity: string;
}

interface Device {
  deviceId: string;
  deviceName: string;
  associatedUsers: AssociatedUser[];
}

interface DeviceAssociatedUsersListProps {
  devices: Device[];
}

export const DeviceAssociatedUsersList = ({ devices }: DeviceAssociatedUsersListProps) => {
  if (devices.length === 0) {
    return null;
  }

  return (
    <ScrollArea className="max-h-[300px] rounded-md border p-3">
      <div className="space-y-3">
        {devices.map((device) => (
          <div
            key={device.deviceId}
            className="text-sm p-3 bg-muted rounded-md space-y-2"
          >
            <div>
              <div className="font-medium">{device.deviceName}</div>
              <div className="text-xs text-muted-foreground mt-1">ID: {device.deviceId}</div>
            </div>
            
            {device.associatedUsers.length > 0 && (
              <div className="pl-3 border-l-2 border-border space-y-2">
                <div className="text-xs font-medium text-muted-foreground">Associated Users:</div>
                {device.associatedUsers.map((user) => (
                  <div
                    key={user.userId}
                    className="text-xs p-2 bg-background rounded-sm"
                  >
                    <div className="font-medium">
                      {user.firstName} {user.lastName}
                      <span className="ml-2 px-1.5 py-0.5 bg-primary/10 text-primary rounded text-[10px] uppercase font-semibold">
                        {user.identity}
                      </span>
                    </div>
                    {user.email && (
                      <div className="text-muted-foreground mt-0.5">{user.email}</div>
                    )}
                    <div className="text-muted-foreground mt-0.5">ID: {user.userId}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </ScrollArea>
  );
};
